'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import { ChevronLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';

export function BackButton() {
  const router = useRouter();

  return (
    <Button
      variant="ghost"
      className="text-primary hover:text-grey-900 focus-visible:text-primary active:text-primary disabled:text-grey-400 dark:hover:text-grey-200 dark:focus-visible:text-grey-400 dark:active:text-grey-400 dark:disabled:text-grey-800 flex w-auto self-start px-0 py-1 text-base dark:text-neutral-100"
      size="sm"
      onClick={() => router.back()}
    >
      <ChevronLeft className="size-5! stroke-2!" />
      Back
    </Button>
  );
}
